import { BatchStatus } from "@wingspanhq/wingspan-api-sdk";
import { UrlQueryFilter } from "../../../../../shared/hooks/useUrlQuery";

/** Sentinel for the leading "All" option — means "send no status filter". */
export const STATUS_FILTER_ALL = "All";

export interface PayableImportBatchFilter extends UrlQueryFilter {
  status?: BatchStatus | typeof STATUS_FILTER_ALL;
}
